ux-iws-sf-page-header {
    display: block;
    width: 100%;
    box-sizing: border-box;
}
